import { LinkTilesRender, LinkTilesPreview, LinkTilesEditor } from './LinkTilesElement';
import { defaultSlots } from '../linkTiles';

// EVERY KIND OF ELEMENT A SPACE'S HOME PAGE CAN HOLD. To add a kind: give it a definition here (and add its type to ELEMENT_TYPES in backend/helpers/space_layouts.py, which is what the server
// accepts). It then appears in the Spaces Builder's element list with its preview, and can be placed on any page.
//   type          what the server stores
//   name          shown in the element list
//   description   one line under the name
//   sizes         the sizes it is designed for (w columns of 12, h rows). The first is what a new one gets. More sizes can be added as they are designed.
//   minW / minH   the smallest it may be made
//   defaultProps  its settings when added
//   Render        how it is drawn on the home page            ({ user, props })
//   Preview       how it looks in the builder                  ({ props, dark })
//   Editor        how its settings are changed in the builder  ({ props, onChange })
export const ELEMENT_DEFS = {
  link_tiles: {
    type: 'link_tiles',
    name: 'Link tiles',
    description: 'Square illustrated tiles for the key links: eleven to choose from, up to ten showing at once. Choose which links show (the eye), in what order, and what each is called.',
    sizes: [
      { id: 'full', label: 'Full width', w: 12, h: 3 },
      { id: 'three-quarters', label: 'Three quarters', w: 9, h: 3 },
      { id: 'half', label: 'Half width', w: 6, h: 3 },
    ],
    minW: 4,
    minH: 2,
    defaultProps: () => ({ slots: defaultSlots() }),
    Render: LinkTilesRender,
    Preview: LinkTilesPreview,
    Editor: LinkTilesEditor,
  },
};

export const elementDef = (type) => ELEMENT_DEFS[type] || null;
export const listElementDefs = () => Object.values(ELEMENT_DEFS);
// { [type]: { minW, minH } }, for the layout rules (spaces/layoutGrid.js).
export const elementMinSizes = () => Object.fromEntries(Object.values(ELEMENT_DEFS).map((def) => [def.type, { minW: def.minW, minH: def.minH }]));
